import { useState } from "react";
import { useLoaderData, useParams } from "react-router-dom";
import { PlateModal } from "../../components/PlateModal";
import { doFetch } from "../../utils/doFetch";
import { GangWayReportsResults } from "./GangWayReportsResults";
import { IGangWayReportResultsData } from "./GangWayResultsData";

export const gangWayReportsResultsRouteLoader = async ({ request, params }: { request: any, params: any }) =>
  doFetch(
    `audit-report/gangway/${params.date}/${params.shift}`,
    { signal: request.signal },
    true,
    true,
  )

export const GangWayReportsResultsRoute = () => {
  const data = useLoaderData() as IGangWayReportResultsData;
  const params = useParams();
  const { date } = params;
  const [regId, setRegId] = useState(0);
  const [board, setBoard] = useState('');

  const formattedDate = (date: string | undefined): string => {
    return date ? `${date.slice(0, 2)}.${date.slice(2, 4)}.${date.slice(4)}` : '';
  }

  const onOpenClosePlateModal = (regId = 0, board = '') => {
    setRegId(regId);
    setBoard(board);
  }

  return (
    <>
      <GangWayReportsResults
        date={formattedDate(date)}
        data={data}
        onOpenClosePlateModal={onOpenClosePlateModal}
      />
      {board && regId && <PlateModal
        onClose={() => onOpenClosePlateModal()}
        open={!!regId && !!board}
        board={board}
        id={Number(regId)}
      />}
    </>
  )
}